import { Component } from '@angular/core';
import {GlobalService} from './global.service';
import {ApiService} from './api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'cart';
  userDetails: any;

  constructor(public globalService: GlobalService, public httpService: ApiService){
    if (this.globalService.isLoggedIn) {
      this.globalchecklogintoken();
    }
  }

  ngOnInit(){
    if(localStorage.getItem('cartquantity') === null){
      localStorage.setItem('cartquantity', '-1');
    }
  }

  globalchecklogintoken(): any {
    // console.log('123');
    if (this.globalService.isLoggedIn) {
      let url = "user/logincheck";
      let data = {
        "userId": localStorage.getItem('userToken')
      };
      this.httpService.postFormDataBase(url, data).subscribe(response => {
        if (!response.login) {
          // this.globalService.frommyaccountforhome = true;
          this.logOut();
          window.location.href = '/';
        }
      });
      // return false;
    }
  }

  public logOut() {
    if (this.globalService.isBrowser) {
      this.userDetails = localStorage.getItem("userDetails") ? JSON.parse(localStorage.getItem("userDetails")) : null;
    }
    let urlForgotPassword = "user/logout";
    // this.mode = 'indeterminate';
    let data = { userId: this.userDetails ? this.userDetails['_id'] : null };
    this.httpService.postFormData(urlForgotPassword, data).subscribe(response => {
      if (response.success) {
        this.globalService.isLoggedIn = false;
        if (this.globalService.isBrowser) {
          let quantity = Number(localStorage.getItem('cartquantity'));
          console.log(quantity);
          while (quantity > -1) {
            localStorage.removeItem('cartdata_' + quantity);
            quantity = quantity - 1;
          }
          //   for(let i = quantity; i >= 0; i++){
          //     localStorage.removeItem('cartdata_' + i);
          //   }

          this.globalService.cartquantity = 0;
          localStorage.removeItem('cartquantity');
          localStorage.removeItem('userDetails');
          localStorage.removeItem('userToken');
          localStorage.removeItem("userEmail");
          localStorage.removeItem("userPass");
          localStorage.removeItem('planpayment');
          localStorage.removeItem('dataArray');
          window.location.href = '/';
        }
        // this.router.navigate(['/']);
      }
      localStorage.removeItem('cartquantity');
      localStorage.removeItem('userDetails');
      localStorage.removeItem('userToken');
      localStorage.removeItem("userEmail");
      localStorage.removeItem('planpayment');
      localStorage.removeItem('dataArray');
      localStorage.removeItem("userPass");
      // this.mode = 'indeterminate';
    });
  }

}
